export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_q01_a.e3f76817.png";